// import '@babel/polyfill'
// import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import helper from './helper'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import { library } from '@fortawesome/fontawesome-svg-core'
//import { faTimes, faBars, faUserSecret  } from '@fortawesome/free-solid-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { faFacebookSquare, faLine } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
//library.add(faTimes, faBars, faCopyright, faFilePdf, faFacebookSquare, faLine, faUserSecret )
library.add(fas, far, faFacebookSquare, faLine )
Vue.component('font-awesome-icon', FontAwesomeIcon)

import Dayjs from 'vue-dayjs';
Vue.use(Dayjs);

import numeral from 'numeral'
Vue.prototype.numeral = numeral

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect)

import { saveAs } from 'file-saver';
Vue.prototype.saveAs = saveAs

import FormInput from "@/components/FormInput";
Vue.component('FormInput', FormInput)
import FormDate from "@/components/FormDate";
Vue.component('FormDate', FormDate)


import * as yup from "yup";
yup.setLocale({
    // use constant translation keys for messages without values
    mixed: {
        required: 'กรุณากรอกข้อมูล',
    },
    string: {
        email: 'กรุณากรอกอีเมลที่ถูกต้อง',
        length: 'กรุณากรอกข้อมูล ${length} ตัวอักษร',
        min: 'ต้องไม่น้อยกว่า ${min} ตัวอักษร',
        max: 'ต้องไม่เกิน ${max} ตัวอักษร',
    },
    // use functions to generate an error object that includes the value from the schema
    number: {
        min: 'จำนวนต้องไม่น้อยกว่า ${min}',
        max: 'จำนวนต้องไม่มากกว่า ${max}',
    },
});

Vue.prototype.yup = yup

Vue.config.productionTip = false

import '@/assets/sass/index.scss'
import '@/assets/fonts/font.css'
// import '@/assets/sass/style.scss'

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
